/*
 * Wallet Watch Application configuration
 *
 * Copyright (c) 2021 Dev Null Productions - All Rights Reserved
 */

module.exports = {
  // Backend URL to get/set data
  //BACKEND_URL : "http://localhost:3000",
  BACKEND_URL : "https://api.blocktr.ac",

  // Supported blockchains
  BLOCKCHAINS : ['btc', 'eth', 'xrp', 'xlm']
}
